(function () {
  if (window.innerWidth < 1068) return;

  const bar = document.querySelector('.facets--bar');
  if (!bar) return;

  const OFFSET_TOP = 120;
  const naturalTop = bar.getBoundingClientRect().top + window.scrollY;
  let placeholder = null;

  function applyFixed() {
    if (bar.classList.contains('is-bar-fixed')) return;
    placeholder = document.createElement('div');
    placeholder.style.height = bar.offsetHeight + 'px';
    bar.parentNode.insertBefore(placeholder, bar);
    bar.style.width = bar.offsetWidth + 'px';
    bar.classList.add('is-bar-fixed');
  }

  function removeFixed() {
    if (!bar.classList.contains('is-bar-fixed')) return;
    bar.classList.remove('is-bar-fixed');
    bar.style.width = '';
    if (placeholder) {
      placeholder.remove();
      placeholder = null;
    }
  }

  window.addEventListener('scroll', function () {
    if (window.innerWidth < 1068) {
      removeFixed();
      return;
    }
    if (window.scrollY >= naturalTop - OFFSET_TOP) {
      applyFixed();
    } else {
      removeFixed();
    }
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (bar.classList.contains('is-bar-fixed')) {
      bar.style.width = bar.parentNode.offsetWidth + 'px';
    }
  });
})();
